import React, { useRef, useState, useMemo, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Context } from "../../Reducers/Store";
import DataGrid from "../../components/DataGrid/index.js";
import Toggle from "../../components/DataGrid/toggle.js";

export default function ClienteList() {
  const [state] = useContext(Context);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const gridRef = useRef();

  const filtroInicial = searchParams.get("filtro") || "";
  const [ativoFiltro, setAtivoFiltro] = useState(searchParams.get("ativo") ?? "true");
  const isNormalUser = state?.profile?.tipo_usuario === "ContaUsuario";

  const handleToggleStatus = async (id, ativo) => {
    try {
      await axios.put(`${process.env.REACT_APP_API}/empresa/${id}/status`, {
        id,
        ativo: !ativo
      });
      gridRef.current?.refresh();
    } catch (error) {
      console.error("Erro ao alterar status:", error);
    }
  };

  const handleAtivoChange = (valor) => {
    setAtivoFiltro(valor);
    const params = new URLSearchParams(searchParams);
    if (valor !== "") {
      params.set("ativo", valor);
    } else {
      params.delete("ativo");
    }
    setSearchParams(params);
  };

  const columns = [
    {
      field: "nome",
      header: "Nome",
      sortable: true,
      render: (row) => (
        <div className="flex flex-col">
          <span className="font-medium text-gray-800">{row.nome}</span>
          {row.nomeFantasia && (
            <span className="text-xs text-gray-500">{row.nomeFantasia}</span>
          )}
        </div>
      ),
    },
    {
      field: "documento",
      header: "Documento",
      sortable: true,
      render: (row) => row.documento || "-",
    },
    {
      key: "ativo",
      header: "Ativo",
      className: "text-center",
      headerClassName: "text-center",
      width: "100px",
      render: (row) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Toggle
            value={row.ativo}
            onChange={() => handleToggleStatus(row.id, row.ativo)}
          />
        </div>
      ),
    },
    {
      key: "acoes",
      header: "Ações",
      width: "140px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <div className="flex items-center justify-center gap-1">
          {/* Botão Links */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/clientes/${row.id}/links`);
            }}
            className="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded"
            title="Gerenciar Links"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
            </svg>
          </button>

          {/* Botão Editar */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/clientes/${row.id}`);
            }}
            className="p-2 text-gray-600 hover:text-slate-900 hover:bg-gray-100 rounded"
            title="Editar"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const externalFilters = useMemo(() => {
    const filters = {};
    if (ativoFiltro !== "") filters.ativo = ativoFiltro;
    return filters;
  }, [ativoFiltro]);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div>
          <h1 className="text-xl font-bold">Clientes</h1>
          {ativoFiltro !== "true" && (
            <button
              onClick={() => {
                setAtivoFiltro("true");
                navigate("/clientes?ativo=true");
              }}
              className="text-sm text-blue-600 hover:underline"
            >
              Limpar filtros
            </button>
          )}
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600">Status:</span>
          <select
            value={ativoFiltro}
            onChange={(e) => handleAtivoChange(e.target.value)}
            className="border rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-slate-300"
          >
            <option value="true">Ativos</option>
            <option value="false">Inativos</option>
            <option value="">Todos</option>
          </select>
        </div>
      </div>

      <DataGrid
        ref={gridRef}
        endpoint={`${process.env.REACT_APP_API}/empresa`}
        columns={columns}
        filters={externalFilters}
        initialFilter={filtroInicial}
        emptyMessage="Nenhum cliente cadastrado"
        emptyAction={
          <button
            onClick={() => navigate("/clientes/novo")}
            className="px-4 py-2 text-sm rounded bg-slate-900 text-white hover:bg-slate-800"
          >
            Cadastrar primeiro cliente
          </button>
        }
        headerAction={
          !isNormalUser && (
            <button
              onClick={() => navigate("/clientes/novo")}
              className="px-4 py-2 text-sm rounded bg-slate-900 text-white hover:bg-slate-800"
            >
              Novo Cliente
            </button>
          )
        }
        onRowClick={(row) => navigate(`/clientes/${row.id}`)}
      />
    </div>
  );
}